import { FormControl, FormItem, FormLabel, RadioGroupItem } from "@patient-watch/ui";
import { cn } from "@patient-watch/ui/utils";
import { Check } from "lucide-react";

const StyledRadioItem = ({
    option,
    isSelected,
}: {
    option: {
        value: string;
        label: string;
        description: string;
        bgColor: string;
        color: string;
        selectedBorderColor: string;
        selectedBgColor: string;
        borderColor: string;
    };
    isSelected: boolean;
}) => {
    return (
        <FormItem
            key={option.value}
            className={`w-full cursor-pointer rounded-lg border-2 pl-4 transition-all duration-200 hover:shadow-md focus-within:ring-2 focus-within:ring-offset-2 ${
                isSelected
                    ? `${option.selectedBorderColor} ${option.selectedBgColor} shadow-lg ring-2 ${option.borderColor.replace(
                          "border-",
                          "ring-"
                      )}`
                    : `${option.borderColor} ${option.bgColor} hover:shadow-md`
            }`}
        >
            <div className="flex items-center space-x-4">
                <FormControl>
                    <RadioGroupItem value={option.value} className="p-1 w-6 h-6" />
                </FormControl>
                <FormLabel className="flex flex-1 justify-between items-center py-4 pr-4 cursor-pointer">
                    <div className="flex flex-col pr-4">
                        <span className="font-medium text-lg">{option.label}</span>
                        <span className="text-gray-500 text-sm">{option.description}</span>
                    </div>
                    <div
                        className={cn(
                            "flex justify-center items-center rounded-full w-6 h-6 aspect-square",
                            option.bgColor
                        )}
                    >
                        {isSelected && <Check className={`w-4 h-4 ${option.color}`} />}
                    </div>
                </FormLabel>
            </div>
        </FormItem>
    );
};

export default StyledRadioItem;
